import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { QuoteData, QuoteSessionService, QuoteType } from '@iqd/shared-quoting';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from '../app.module';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
})
export class BudgetComponent implements OnInit, OnDestroy {
  @ViewChild('tabs') private tabs: NgbNav;
  resultEnabled = false;
  dwgReady = false;
  quoteData: QuoteData;
  quoteDataSubscription: Subscription;
  budgetQuoteId: number;

  private settings: Observable<any>;

  constructor(
    public quoteSessionService: QuoteSessionService,
    private store: Store<AppState>
  ) {
    this.settings = this.store.select(
      (state) => state.settings.currentSettings
    );
    this.quoteSessionService.setup(this.settings);
  }

  ngOnInit(): void {
    this.quoteDataSubscription = this.quoteSessionService.quoteData.subscribe(
      (quoteData) => {
        this.quoteData = quoteData;
      }
    );
    this.newBudget();
  }

  newBudget(): void {
    this.quoteSessionService.newSession(QuoteType.Budget);
  }

  onSubmit(): void {
    this.resultEnabled = true;
  }

  onSuccess(data: any): void {
    this.budgetQuoteId = data.budgetQuoteId;
    this.tabs.select('result');
  }

  ngOnDestroy(): void {
    if (this.quoteDataSubscription) {
      this.quoteDataSubscription.unsubscribe();
    }
    if (this.quoteSessionService) {
      this.quoteSessionService.endSession();
    }
    if (this.quoteSessionService) {
      this.quoteSessionService.destroy();
    }
  }
}
